import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBSsS1yEGF-_Tx7egGF1RJT-BJE4PEX_bU",
  authDomain: "reference-hydra-496416-v9.firebaseapp.com",
  projectId: "reference-hydra-496416-v9",
  storageBucket: "reference-hydra-496416-v9.firebasestorage.app",
  messagingSenderId: "326840681512",
  appId: "1:326840681512:web:8c3195d512971afdbce11d",
  measurementId: "G-F5HPRV86QW"
};

if (!firebase.apps || firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;
export { firebaseConfig };
